import * as React from "react"
import { cn } from "src/common/utils"

type DividerProps = {
  className?: string
}

const Divider: React.FC<DividerProps> = ({ className }) => {
  return <div className={cn("border-t border-border my-4", className)} />
}

export { Divider } 